import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GeneralFilterableIndex = _resolveComponent("GeneralFilterableIndex")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_GeneralFilterableIndex, {
      showkeywords: _ctx.showkeywords,
      filtergroupids: _ctx.filtergroupids,
      filteryear: _ctx.filteryear,
      parentid: _ctx.parentid,
      pagesize: _ctx.pagesize,
      title: _ctx.title,
      resultType: _ctx.resultType,
      baseUri: _ctx.baseUri,
      locale: _ctx.local,
      language: _ctx.language,
      personalisationGroupIds: _ctx.personalisationGroupIds
    }, null, 8, ["showkeywords", "filtergroupids", "filteryear", "parentid", "pagesize", "title", "resultType", "baseUri", "locale", "language", "personalisationGroupIds"])
  ]))
}